/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.25",
    versionName: "0.2.0-nightly.2025.7.25",
    versionChannel: "nightly",
    buildDate: "2025-07-25T00:07:56.200Z",
    commitHash: "13570e7ab5c24835b3dae4ca339337ea786f52a7",
};
